import {objectReducer} from 'shared/reducers/object-reducer';
import {CLEAR_STUDENT, RECEIVE_STUDENT} from 'shared/actions/student';

export default objectReducer({
  actionProperty: 'student',
  emptyObjectAction: CLEAR_STUDENT,
  mergeObjectAction: RECEIVE_STUDENT,
});
